"use client"

import { motion } from "motion/react"

import type { BriefProgress } from "@/types"

interface ProgressIndicatorProps {
  progress: BriefProgress
  compact?: boolean
}

// Server-resolved metric. The component never re-derives `(p) => p.locked
// || p.accepted_suggestion`. That lives in `Brief::Progress` so all
// surfaces stay aligned (carve-up critique #1).
export function ProgressIndicator({
  progress,
  compact = false,
}: ProgressIndicatorProps) {
  const { filled_slots_count, total_slots, percent } = progress
  if (total_slots === 0) return null

  if (compact) {
    return (
      <div className="bg-secondary h-1 w-full overflow-hidden rounded-full">
        <motion.div
          className="from-brand-400 to-brand-600 h-full rounded-full bg-gradient-to-r"
          initial={{ width: 0 }}
          animate={{ width: `${percent}%` }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        />
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="bg-secondary h-2 w-full overflow-hidden rounded-full">
        <motion.div
          className="from-brand-400 to-brand-600 h-full rounded-full bg-gradient-to-r"
          initial={{ width: 0 }}
          animate={{ width: `${percent}%` }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        />
      </div>
      <p className="text-tertiary text-xs">
        {filled_slots_count}/{total_slots} tracks filled
        {progress.almost_there && " · almost there"}
      </p>
    </div>
  )
}
